
export const disableNumberWheel = {
    
  mounted(el) {
    // 找到 el-input-number 内部的输入框
    const input = el.querySelector('.el-input__inner')
    if (input) {
      // 绑定滚轮事件，手动设置 passive: false
      input.addEventListener('wheel', (e) => {
        e.stopPropagation()
        if (e.cancelable) e.preventDefault()
      }, { passive: false }) // 关键：关闭被动监听，允许 preventDefault
    }
  }
}